const statuses = {
  INACTIVE: 0,
  ACTIVE: 1,
  DISABLED: 2,
  WAITING_USER_ACTION: 3,
  ERROR: 4,
  WAITING_AUTHORIZATION: 5,
};

const texts = {
  [statuses.INACTIVE]: 'Inativo',
  [statuses.ACTIVE]: 'Ativo',
  [statuses.DISABLED]: 'Desabilitado',
  [statuses.WAITING_USER_ACTION]: 'Aguardando ação do usuário',
  [statuses.ERROR]: 'Erro',
  [statuses.WAITING_AUTHORIZATION]: 'Aguardando autorização',
};

export default statuses;

export const getText = (status) => texts[status];
